module.exports = __webpack_public_path__ + "static/media/NotasFiscais10.48cee1b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancNotasFiscais/NotasFiscais10.png
// module id = 2141
// module chunks = 0